import React, { useEffect, useState, useCallback } from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import AddClass from "./AddClass";
import AddElev from "./AddElev";
import { useSelector } from "react-redux";
import { getProfessorAccessibleClasses } from "../../utils";
import ClassGrid from "../../Components/ClassGrid";
import withErrorBoundary from "../../Components/withErrorComponent";
function Clase() {
  const user = useSelector((state) => state.user);
  const [claseToDisplay, setClaseToDisplay] = useState([]);
  const [open, setOpen] = useState(false);
  const [addElev, setAddElev] = useState(false);
  const profesori = useSelector((state) => state.profesori);
  const clase = useSelector((state) => state.clase);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const navigate = useNavigate();

  const fetchData = useCallback(async () => {
    // Folosește noua funcție din utils
    const filteredClase = await getProfessorAccessibleClasses(user.uid, clase);
    setClaseToDisplay(filteredClase);
  }, [user.uid, clase]);

  useEffect(() => {
    if (user.type === "admin") setClaseToDisplay(clase);
    else if (user.type === "profesor") {
      fetchData();
    }
  }, [clase, user, fetchData]);

  return (
    <div>
      <div style={{ marginBottom: "24px" }}>
        <h1
          style={{
            fontSize: "24px",
            fontWeight: "600",
            color: "#262626",
            marginBottom: "4px",
          }}
        >
          Clase
        </h1>
        <p style={{ color: "#8c8c8c", fontSize: "14px", margin: 0 }}>
          Vizualizează și gestionează clasele din școală
        </p>
      </div>
      <div style={{ display: "flex", gap: "10px", marginBottom: "24px" }}>
        {user.type === "admin" && (
          <>
            {" "}
            <Button
              type="primary"
              size="large"
              onClick={(e) => {
                setOpen(true);
                e.preventDefault();
              }}
            >
              Adaugă Clasa
            </Button>
            <Button
              type="primary"
              size="large"
              onClick={(e) => {
                setAddElev(true);
                e.preventDefault();
              }}
            >
              Adaugă Elev
            </Button>
          </>
        )}
      </div>
      {user.type === "admin" && (
        <>
          <AddClass
            open={open}
            setConfirmLoading={setConfirmLoading}
            confirmLoading={confirmLoading}
            setOpen={setOpen}
          />
          <AddElev
            open={addElev}
            setConfirmLoading={setConfirmLoading}
            confirmLoading={confirmLoading}
            setOpen={setAddElev}
          />
        </>
      )}

      <ClassGrid
        classes={[...claseToDisplay].sort((a, b) => {
          // Function to get numeric value for sorting
          const getClassOrder = (anClasa) => {
            const grade = anClasa?.toLowerCase();
            switch (grade) {
              case "pregătitoare":
                return 0;
              case "i":
                return 1;
              case "ii":
                return 2;
              case "iii":
                return 3;
              case "iv":
                return 4;
              case "v":
                return 5;
              case "vi":
                return 6;
              case "vii":
                return 7;
              case "viii":
                return 8;
              case "ix":
                return 9;
              case "x":
                return 10;
              case "xi":
                return 11;
              case "xii":
                return 12;
              case "xiii":
                return 13;
              // Adaugă clase de liceu/universitate cu "Anul"
              case "anul i":
                return 14;
              case "anul ii":
                return 15;
              case "anul iii":
                return 16;
              case "anul iv":
                return 17;
              case "anul v":
                return 18;
              default:
                return 999; // Unknown grades go to end
            }
          };

          const orderA = getClassOrder(a?.anClasa);
          const orderB = getClassOrder(b?.anClasa);

          // First sort by grade order
          if (orderA !== orderB) {
            return orderA - orderB;
          }

          // If same grade, sort by identifier (A, B, C, etc.)
          const identifierA = a?.identificator || "";
          const identifierB = b?.identificator || "";
          return identifierA.localeCompare(identifierB);
        })}
        onClassClick={(clasa) => navigate(`/class/${clasa.id}`)}
        profesori={profesori}
      />
    </div>
  );
}

export default withErrorBoundary(Clase);
